import { gql } from '@apollo/client';

export const VENDOR_ORDERS = gql`
  query VendorOrdersQuery($vendorId: String!, $limit: Int, $page: Int) {
    vendorOrders(vendorId: $vendorId, limit: $limit, page: $page) {
      orderNumber
      status
      createdAt
      updatedAt
      deliveredAt
      deliveryAddress
      deliveryAgentId
      isBatchOrder
      notes
      totalAmount
      paymentMethod
      vendorResponses
      vendorId
      userId
      razorpayData {
        amount
        currency
        razorpayOrderId
      }
      items {
        id
        orderId
        productId
        productName
        productImageThumbnail
        barcode
        sku
        category
        quantity
        unit
        unitSize
        status
        isReturnable
        returnDeadline
        shippedAt
        deliveredAt
        uniqueCodeOtp
        unitPrice {
          amount
          currency
          formatted
        }
        totalPrice {
          amount
          currency
          formatted
        }
        vendorTotalPrice {
          amount
          currency
          formatted
        }
        vendorPlatformFee {
          amount
          currency
          formatted
        }
        vendorPaymentAmount {
          amount
          currency
          formatted
        }
        handlingFee {
          amount
          currency
          formatted
        }
        handlingFeeDiscount {
          amount
          currency
          formatted
        }
        netHandlingFee {
          amount
          currency
          formatted
        }
        refundAmount {
          amount
          currency
          formatted
        }
      }
    }
  }
`;

export const REJECT_ORDER = gql`
  mutation RejectOrder($orderItemId: String!, $reason: RejectionReason!) {
    rejectOrder(input: { orderItemId: $orderItemId, reason: $reason }) {
      success
      message
      errors {
        code
        field
        message
      }
    }
  }
`;

export const MARK_ORDER_READY_FOR_PICKUP_SUBSCRIPTION = gql`
  subscription MarkOrderReadyForPickup($orderItemId: String!) {
    markOrderReadyForPickup(orderItemId: $orderItemId) {
      success
      message
      orderItemStatus
      orderStatus
      error {
        code
        field
        message
      }
    }
  }
`;

/** Reasons a vendor can pick when rejecting an order item. */
export const GET_REJECTION_REASONS = gql`
  query GetRejectionReasons($languageCode: String) {
    getRejectionReasons(languageCode: $languageCode) {
      displayValue
      enumName
      value
    }
  }
`;
